// extracted by mini-css-extract-plugin
module.exports = {"setCvAsDefault":"NewCv_setCvAsDefault__NFqtA","setCvAsDefaultTooltip":"NewCv_setCvAsDefaultTooltip__6GGp8"};